import { render, staticRenderFns } from "./AssignGroup.vue?vue&type=template&id=0cea2c57&scoped=true&"
import script from "./AssignGroup.vue?vue&type=script&lang=js&"
export * from "./AssignGroup.vue?vue&type=script&lang=js&"
import style0 from "./AssignGroup.vue?vue&type=style&index=0&id=0cea2c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea2c57",
  null
  
)

export default component.exports